app.component("practiceAdminConsole", {
	templateUrl: "app/src/js/components/admin/practiceConsole.html",
	controller: "practiceAdminController",
	bindings: {
		// type: '@',
	},
});

app.controller("practiceAdminController", [
	"$scope",
	"$modal",
	"PRACTICE_TYPE",
	"AdminService",
    "NgTableParams",
	"DHB_LIST",
    "$window",
    "countryConfig",
    "TIMEZONE_TYPE",
    "TranscriptionSeatsAPI",
    function ($scope, $modal, PRACTICE_TYPE, AdminService, NgTableParams, DHB_LIST, $window, countryConfig, TIMEZONE_TYPE, TranscriptionSeatsAPI) {
		$scope.practiceTypeOptions = PRACTICE_TYPE;
		$scope.dhbOptions = DHB_LIST;
		$scope.formDisplay = false;
        $scope.AS = AdminService;
        $scope.AS.isProcessing = false;
		$scope.display = {};
        $scope.display.address = '';
        $scope.countryConfig = countryConfig;
        $scope.TIMEZONE_TYPE = TIMEZONE_TYPE;
        $scope.TSAPI = TranscriptionSeatsAPI;

        // Toggle geo address country from countryConfig.
        if (countryConfig.countryCode === "NZ") {
            $scope.autocompleteOptions = {
                componentRestrictions: { country: "nz" },
                types: ["geocode"],
            };
        } else if (countryConfig.countryCode === "AU") {
            $scope.autocompleteOptions = {
                componentRestrictions: { country: "au" },
                types: ["geocode"],
            };
        }

		$scope.fetchPractices = function () {
            $scope.AS.getAvailablePractices().then(function (resp) {
				$scope.tableParams = new NgTableParams({
                    count: 10,
					sorting: { id: 'asc' },
                }, {
                    counts: [],
                    dataset: resp.data
                });
            }, function (error) {

            }).then(function () {
                $scope.AS.isProcessing = false;
            })
        };

		$scope.fetchPractices();

		$scope.selectPractice = function (practice, index) {
			$scope.createPractice();
			$scope.$ctrl.data.id = practice.id;
            $scope.fetchSelectedPractice(practice.id);
		};

		$scope.createPractice = function () {
			$scope.$ctrl.data = {};
            // $scope.$ctrl.data.registration = {};
            // $scope.$ctrl.data.practices = [];
            // $scope.$ctrl.data.roles = [];
            $scope.display = {};
		    $scope.display.address = '';
            // $scope.roleModel = [];
            // $scope.fetchPractices();
            $scope.resetInvoiceSeats();
            $scope.formDisplay = true;
		};

		$scope.fetchSelectedPractice = function (practiceId) {
            $scope.AS.getPracticeDetail(practiceId).then(function (resp) {
                $scope.$ctrl.data = resp.data;
                // $scope.roleModel = $scope.$ctrl.data.roles.map(t => ({ id: t }));
                if ($scope.$ctrl.data.addresses && $scope.$ctrl.data.addresses.length > 0) {
                    $scope.display.address = $scope.$ctrl.data.addresses[0].line1;
                }
                // $scope.display.address = $scope.CP.patient.addresses[0].line1;
            }, function (error) {

            }).then(function () {
                $scope.AS.isProcessing = false;
            })

            $scope.loadInvoiceSubscription(practiceId);
        };

        // =================================================================
        // AI transcription seat billing (invoiced enterprise agreements)
        // =================================================================

        $scope.resetInvoiceSeats = function () {
            $scope.invoiceSeats = {
                subscription: null,
                form: { standardSeats: 0, premiumSeats: 0, paidUntil: null },
                isLoading: false,
                isSaving: false,
                confirmingRevoke: false,
                errorMessage: null,
                successMessage: null,
            };
        };

        $scope.resetInvoiceSeats();

        $scope.loadInvoiceSubscription = function (practiceId) {
            $scope.resetInvoiceSeats();
            $scope.invoiceSeats.isLoading = true;

            TranscriptionSeatsAPI.getInvoiceSubscription(practiceId).then(function (resp) {
                $scope.applyInvoiceSubscription(resp.data || null);
            }, function (error) {
                $scope.invoiceSeats.errorMessage = TranscriptionSeatsAPI.getErrorMessage(error,
                    "Unable to load the seat subscription.");
            }).then(function () {
                $scope.invoiceSeats.isLoading = false;
            });
        };

        /**
         * Prefills the grant form from the current invoiced state, so an update starts from what
         * the practice already holds.
         */
        $scope.applyInvoiceSubscription = function (subscription) {
            $scope.invoiceSeats.subscription = subscription;

            if (subscription && subscription.billing_type === "INVOICE") {
                $scope.invoiceSeats.form.standardSeats =
                    TranscriptionSeatsAPI.getAllocation(subscription, "STANDARD").quantity_owned;
                $scope.invoiceSeats.form.premiumSeats =
                    TranscriptionSeatsAPI.getAllocation(subscription, "PREMIUM").quantity_owned;
                $scope.invoiceSeats.form.paidUntil =
                    subscription.paid_until_utc ? new Date(subscription.paid_until_utc) : null;
            }
        };

        /**
         * Whether the practice holds a live self-service Stripe subscription, which must be
         * cancelled before invoiced seats can be granted so it is never billed twice.
         */
        $scope.hasLiveStripeSubscription = function () {
            const subscription = $scope.invoiceSeats.subscription;
            return !!subscription
                && subscription.billing_type !== "INVOICE"
                && TranscriptionSeatsAPI.isSubscriptionLive(subscription);
        };

        $scope.isInvoiceBilled = function () {
            const subscription = $scope.invoiceSeats.subscription;
            return !!subscription && subscription.billing_type === "INVOICE";
        };

        $scope.saveInvoiceSeats = function () {
            $scope.invoiceSeats.errorMessage = null;
            $scope.invoiceSeats.successMessage = null;
            $scope.invoiceSeats.confirmingRevoke = false;

            const form = $scope.invoiceSeats.form;
            const standard = parseInt(form.standardSeats, 10) || 0;
            const premium = parseInt(form.premiumSeats, 10) || 0;

            if (standard < 0 || premium < 0) {
                $scope.invoiceSeats.errorMessage = "Seat counts cannot be negative.";
                return;
            }

            if (standard + premium <= 0) {
                $scope.invoiceSeats.errorMessage = "Grant at least one seat, or revoke the subscription instead.";
                return;
            }

            if (!form.paidUntil) {
                $scope.invoiceSeats.errorMessage = "Choose the date the practice has paid until.";
                return;
            }

            const seats = [
                { tier: "STANDARD", quantity: standard },
                { tier: "PREMIUM", quantity: premium },
            ];

            $scope.invoiceSeats.isSaving = true;

            TranscriptionSeatsAPI.saveInvoiceSubscription($scope.$ctrl.data.id, seats, toPaidUntilUtc(form.paidUntil))
                .then(function (resp) {
                    $scope.applyInvoiceSubscription(resp.data || null);
                    $scope.invoiceSeats.successMessage = "Invoiced seats saved.";
                }, function (error) {
                    $scope.invoiceSeats.errorMessage = TranscriptionSeatsAPI.getErrorMessage(error,
                        "Unable to save the invoiced seats.");
                }).then(function () {
                    $scope.invoiceSeats.isSaving = false;
                });
        };

        /**
         * Revokes on the second click, so a slip of the mouse cannot release every seat in the
         * practice.
         */
        $scope.revokeInvoiceSeats = function () {
            $scope.invoiceSeats.errorMessage = null;
            $scope.invoiceSeats.successMessage = null;

            if (!$scope.invoiceSeats.confirmingRevoke) {
                $scope.invoiceSeats.confirmingRevoke = true;
                return;
            }

            $scope.invoiceSeats.confirmingRevoke = false;
            $scope.invoiceSeats.isSaving = true;

            TranscriptionSeatsAPI.revokeInvoiceSubscription($scope.$ctrl.data.id).then(function () {
                $scope.invoiceSeats.successMessage = "Invoiced seats revoked and all assigned seats released.";
                return TranscriptionSeatsAPI.getInvoiceSubscription($scope.$ctrl.data.id).then(function (resp) {
                    $scope.applyInvoiceSubscription(resp.data || null);
                });
            }, function (error) {
                $scope.invoiceSeats.errorMessage = TranscriptionSeatsAPI.getErrorMessage(error,
                    "Unable to revoke the invoiced seats.");
            }).then(function () {
                $scope.invoiceSeats.isSaving = false;
            });
        };

        /**
         * The date picker yields local midnight; the server compares UTC strings. Sending the end
         * of the chosen day in UTC guarantees the practice keeps its seats for the whole of that
         * day, wherever they are.
         */
        function toPaidUntilUtc(paidUntil) {
            const pad = function (value) {
                return value < 10 ? "0" + value : "" + value;
            };

            return paidUntil.getFullYear() + "-" + pad(paidUntil.getMonth() + 1) + "-"
                + pad(paidUntil.getDate()) + "T23:59:59";
        }

		$scope.setAddress = function () {
			if(!$scope.display || !$scope.display.address){
				return;
			}
            $scope.$ctrl.data.addresses = [{
                type: "POSTAL",
                line1: $scope.display.address.formatted_address,
                line2: "",
                city: "",
                postCode: "",
                country: "",
            }];
            $scope.display.address.address_components.map(function (obj) {
                if (obj.types.indexOf("postal_code") !== -1) {
                    $scope.$ctrl.data.addresses[0].postCode = obj.long_name;
                }
            });

            $scope.display.address.address_components.map(function (obj) {
                if (obj.types.indexOf("country") !== -1) {
                    $scope.$ctrl.data.addresses[0].country = obj.long_name;
                }
            });

            $scope.display.address.address_components.map(function (obj) {
                if (obj.types.indexOf("locality") !== -1) {
                    $scope.$ctrl.data.addresses[0].city = obj.long_name;
                }
            });

            $scope.display.address.address_components.map(function (obj) {
                if (obj.types.indexOf("sublocality") !== -1) {
                    $scope.$ctrl.data.addresses[0].line2 = obj.long_name;
                }
            });

        };

		$scope.registerOrUpdatePractice = function() {
            // A new practice needs its address picked from the list before there is anything to send. An
            // existing practice may legitimately carry an empty list and must still be editable.
            if (!$scope.$ctrl.data.addresses) {
                $scope.dialogMessage = "Please select the practice address from the list";
                $scope.successModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
                    show: true,
                    title: "Failure",
                });
                return;
            }
            // Dates on PDFs and in the calendar are shown in the practice's timezone, so a practice can't be
            // saved without one. This applies to edits too, so practices saved before it was required pick one up.
            if (!$scope.$ctrl.data.timezone) {
                $scope.dialogMessage = "Please select the practice time zone";
                $scope.successModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
                    show: true,
                    title: "Failure",
                });
                return;
            }
            $scope.$ctrl.data.addresses.forEach(t => delete t.id);
            /** Fix bug 988: Can't update FHIR NHI toggle (https://dev.azure.com/quantric/Quantric/_workitems/edit/988)
            if(!$scope.$ctrl.data.practiceFeatures || !$scope.$ctrl.data.practiceFeatures.nhiFeature){
                delete $scope.$ctrl.data.practiceFeatures;
            } */

            if (!$scope.$ctrl.data.faxNumber || $scope.$ctrl.data.faxNumber.length === 0) {
                delete $scope.$ctrl.data.faxNumber;
            }
            const isEditPractice = $scope.$ctrl.data.id !== undefined
            let handler = $scope.AS.createPractice;
			
            if(isEditPractice){
                handler = $scope.AS.updatePracticeDetail;
            }
			handler($scope.$ctrl.data).then(function (resp) {
                $scope.dialogMessage = isEditPractice ? "Practice Updated" : "Practice Created";
                $scope.successModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
					show: true,
					title: "Success",
                    onHide: function () {
                        $scope.formDisplay = false;
                        $scope.fetchPractices();
                    },
				});
            }, function (error) {
                if (error.data && error.data.status === 409) {
                    $scope.dialogMessage = "Practice already exists";
                    $scope.successModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
                        show: true,
                        title: "Failure",
                    });
                } else {
                    $scope.serverErrorModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                        show: true,
                        title: "CatTrax has encountered an error",
                    });
                }
            }).then(function () {
                $scope.AS.isProcessing = false;
            })
			
		}

		$scope.cancel = function () {
            $scope.createPractice();
            $scope.formDisplay = false;
        };

        $scope.goBack = function () {
            $window.history.back();
        }

        // $scope.$watch(
		// 	"$ctrl.data.practiceFeatures.fhirNhiFeature",
		// 	function (newValue, oldValue) {
		// 		if(newValue){
		// 			$scope.$ctrl.data.practiceFeatures.nhiFeature = true;
		// 		}
		// 	},
		// 	true
		// );
	},
]);
